import React from 'react';
import { useTranslate } from 'react-admin';
import { makeStyles } from '@material-ui/core';
import MuiDrawer from '../../../../base/components/mui/MuiDrawer';
import PaymentDetails from './PaymentDetails';
import { usePaymentIdSync } from '../../hooks/usePaymentIdSync';

const PaymentDetailsDrawer = () => {
  const classes = useStyles();
  const t = useTranslate();

  const { paymentId, setPaymentId } = usePaymentIdSync();

  const open = !!paymentId;

  return (
    <MuiDrawer
      open={open}
      anchor="right"
      onClose={() => setPaymentId()}
      title={t('resources.payment.paymentDetails')}
      classes={{
        root: classes.root,
        paper: classes.paper,
      }}
    >
      {open ? <PaymentDetails /> : null}
    </MuiDrawer>
  );
};

export default PaymentDetailsDrawer;

const useStyles = makeStyles({
  paper: {
    width: '40rem',
    maxWidth: '80%',
  },
  root: {
    zIndex: '1000 !important',
  },
});
